import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrash } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify';
import { apiRoutes } from '../../../../routes/api/apiRoutes';
import { uiRoutes } from '../../../../routes/ui/uiRoutes';

const ModulesAdd = () => {
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    topics: ['']
  });

  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleTopicChange = (index, value) => {
    const updatedTopics = [...formData.topics];
    updatedTopics[index] = value;
    setFormData(prev => ({ ...prev, topics: updatedTopics }));
  };

  const addTopic = () => {
    setFormData(prev => ({ ...prev, topics: [...prev.topics, ''] }));
  };

  const removeTopic = (index) => {
    if (formData.topics.length <= 1) return;
    const updatedTopics = formData.topics.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, topics: updatedTopics }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanedData = {
      name: formData.name,
      type: formData.type,
      topics: formData.topics.filter(topic => topic.trim() !== '')
    };

    if (!cleanedData.name || !cleanedData.type || cleanedData.topics.length === 0) {
      toast.error("All fields are required including at least one topic.");
      return;
    }

    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);

    callAPI('post', apiRoutes.admin.modules, cleanedData);
  };

  if (response?.data && statusCode === 201) {
    toast.success('Module added successfully!');
    setTimeout(() => navigate(uiRoutes.admin.modules.list), 1500);
  }

  return (
    <AdminAppBody loading={loading} content={
      <div className="container">
        <PageHeading title="Add Module" subTitle="Create a new training module" />
        <div className="card shadow rounded-4 p-4 mt-4" style={{ background: '#fdfdfd' }}>
          <form onSubmit={handleSubmit}>
            {/* Module Name */}
            <div className="mb-4">
              <label className="form-label fw-bold">Module Name</label>
              <input
                type="text"
                className="form-control rounded-3 shadow-sm"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter module name"
              />
              <span className="val-message text-danger">
                {error?.message === "ValidationError" && error?.data?.name}
              </span>
            </div>

            {/* Type */}
            <div className="mb-4">
              <label className="form-label fw-bold">Type (Kids or Students)</label>
              <select
                className="form-select rounded-3 shadow-sm"
                name="type"
                value={formData.type}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="kids">Kids</option>
                <option value="students">Students</option>
              </select>
              <span className="val-message text-danger">
                {error?.message === "ValidationError" && error?.data?.type?.[0]}
              </span>
            </div>

            {/* Topics */}
            <div className="mb-4">
              <label className="form-label fw-bold">Topics</label>
              {formData.topics.map((topic, index) => (
                <div key={index} className="d-flex gap-2 mb-2 align-items-center">
                  <input
                    type="text"
                    className="form-control rounded-3 shadow-sm"
                    value={topic}
                    onChange={(e) => handleTopicChange(index, e.target.value)}
                    placeholder={`Topic ${index + 1}`}
                  />
                  {formData.topics.length > 1 && (
                    <button
                      type="button"
                      className="sys-list-table__action delete"
                      onClick={() => removeTopic(index)}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        color: '#dc3545',
                        fontSize: '1.1rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FaTrash />
                    </button>
                  )}
                </div>
              ))}
              <button type="button" className="btn btn-outline-primary mt-2" onClick={addTopic}>
                <FaPlus className="me-1" /> Add Topic
              </button>
            </div>

            {/* Submit */}
            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="btn btn-success px-4 py-2 rounded-3 shadow-sm"
              >
                Save Module
              </button>
            </div>
          </form>
        </div>
      </div>
    } />
  );
};

export default ModulesAdd;
